import { rage, useObservable } from '~/rage';
import { shopLogoByType } from './ShopLogo.model';
import {
	StyledLabelContainer,
	StyledLogo,
	StyledLogoContainer,
	StyledShopName,
	StyledShopTitle,
} from './ShopLogo.styled';

const ShopLogo = (props: React.HTMLAttributes<HTMLDivElement>) => {
	const shopInfo = useObservable(rage.vehicleShop.getShopInfo());

	return (
		<StyledLogoContainer style={{ whiteSpace: 'nowrap' }} {...props}>
			{shopInfo?.id && <StyledLogo src={shopLogoByType[shopInfo?.id]} />}
			<StyledLabelContainer>
				<StyledShopTitle>{shopInfo?.title}</StyledShopTitle>
				<StyledShopName>{shopInfo?.name}</StyledShopName>
			</StyledLabelContainer>
		</StyledLogoContainer>
	);
};

export { ShopLogo };
